// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.TestimonialSection_styledSwiper__I8I\\+J {
  position: relative;
  width: 100%;
  max-width: 72rem;
  margin-left: auto;
  margin-right: auto;
  border-radius: 0.75rem;
  /* Swiper iç sınıflar global olduğu için :global kullan */
}
.TestimonialSection_styledSwiper__I8I\\+J .swiper-pagination {
  position: absolute;
  bottom: 1rem; /* bottom-4 */
  left: 0;
  right: 0; /* inset-x-0 */
  display: flex;
  justify-content: center;
  gap: 0.5rem;
  z-index: 10;
}
.TestimonialSection_styledSwiper__I8I\\+J .swiper-pagination-bullet {
  width: 0.75rem;
  height: 0.75rem;
  border-radius: 9999px;
  background: #9ca3af;
  opacity: 1;
  box-shadow: none;
}
.TestimonialSection_styledSwiper__I8I\\+J .swiper-pagination-bullet-active {
  background: #ffffff !important; /* aktif: beyaz */
}`, "",{"version":3,"sources":["webpack://./src/components/TestimonialsSection/TestimonialSection.module.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;EAEA,yDAAA;AACF;AAAE;EACE,kBAAA;EACA,YAAA,EAAA,aAAA;EACA,OAAA;EACA,QAAA,EAAA,cAAA;EACA,aAAA;EACA,uBAAA;EACA,WAAA;EACA,WAAA;AAEJ;AACE;EACE,cAAA;EACA,eAAA;EACA,qBAAA;EACA,mBAAA;EACA,UAAA;EACA,gBAAA;AACJ;AAEE;EACE,8BAAA,EAAA,iBAAA;AAAJ","sourcesContent":[".styledSwiper {\n  position: relative;\n  width: 100%;\n  max-width: 72rem;\n  margin-left: auto;\n  margin-right: auto;\n  border-radius: 0.75rem;\n\n  /* Swiper iç sınıflar global olduğu için :global kullan */\n  :global(.swiper-pagination) {\n    position: absolute;\n    bottom: 1rem; /* bottom-4 */\n    left: 0;\n    right: 0; /* inset-x-0 */\n    display: flex;\n    justify-content: center;\n    gap: 0.5rem;\n    z-index: 10;\n  }\n\n  :global(.swiper-pagination-bullet) {\n    width: 0.75rem;\n    height: 0.75rem;\n    border-radius: 9999px;\n    background: #9ca3af;\n    opacity: 1;\n    box-shadow: none;\n  }\n\n  :global(.swiper-pagination-bullet-active) {\n    background: #ffffff !important; /* aktif: beyaz */\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"styledSwiper": `TestimonialSection_styledSwiper__I8I+J`
};
export default ___CSS_LOADER_EXPORT___;
